'use client'

import Script from 'next/script'

const KarrotPixelScriptWrapper = () => {
  return (
    <>
      <Script
        src="https://karrot-pixel.business.daangn.com/0.4/karrot-pixel.umd.js"
        strategy="afterInteractive"
      />
      <Script id="karrot-pixel-init" strategy="afterInteractive">
        {`
          window.karrotPixel && window.karrotPixel.init('1745831345301800001');
          window.karrotPixel && window.karrotPixel.track('ViewPage');
        `}
      </Script>
    </>
  )
}

export default KarrotPixelScriptWrapper
